'use strict';

class CreateMember {

    constructor() {

        this.stepone = document.getElementById('stepone');
        this.steptwo = document.getElementById('steptwo');
        this.stepthree = document.getElementById('stepthree');

        this.verifyMembershipButton = document.getElementById('verifymembershipbutton');
        this.verifyPersonalDetailsButton = document.getElementById('verifypersonaldetailsbutton');

        this.finishStepOne = this.finishStepOne.bind(this);
        this.finishStepTwo = this.finishStepTwo.bind(this);
        this.validatePassword = this.validatePassword.bind(this);
        this.validateUserName = this.validateUserName.bind(this);
        this.createWebUser = this.createWebUser.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.addWorkPlaceList = this.addWorkPlaceList.bind(this);
        this.validateWorkPlace = this.validateWorkPlace.bind(this);


        this.addEventListeners();
    }

    validatePassword() {
        var pass1 = document.getElementById("Password").value;
        var pass2 = document.getElementById("VerifyPassword").value;
        pass1 !== pass2 ? document.getElementById("VerifyPassword").setCustomValidity("Lösenord och Verifiera lösenord matchar inte") : document.getElementById("VerifyPassword").setCustomValidity('');
        if (!document.getElementById('VerifyPassword').checkValidity()) {
            return false;
        }
        return true;
    }

    validateUserName() {
        var uname1 = document.getElementById("UserName").value;
        var uname2 = document.getElementById("VerifyUserName").value;
        uname1 !== uname2 ? document.getElementById("VerifyUserName").setCustomValidity("Användarnamn och Verifiera användarnamn matchar inte") : document.getElementById("VerifyUserName").setCustomValidity('');
        if (!document.getElementById('VerifyUserName').checkValidity()) {
            return false;
        }
        return true;
    }

    addValidationError(el, mess) {
        const div = document.createElement("div");
        div.className = "validation-error";
        div.innerHTML += '<p style="color:red">' + mess + '</p>';
        el.parentNode.append(div);
    }

    clearValidationErrors() {
        const elements = document.querySelectorAll('.validation-error');
        var len = elements.length;
        for (var i = 0; i < len; i++) {
            elements[i].parentNode.removeChild(elements[i]);
        }
    }

    validateWorkPlace() {
        const selectListWrapper = document.getElementById('steptwo__workplacelist');
        if (!selectListWrapper.classList.contains('hidden')) {
            if (!document.getElementById('WorkPlace').checkValidity()) {
                document.getElementById('WorkPlace').reportValidity();
                return false;
            }
        }

        return true;
    }

    addEventListeners() {
        var verifyUserNameEl = document.getElementById("VerifyUserName");
        var verifyPasswordEl = document.getElementById("VerifyPassword");
        if (verifyUserNameEl != null) {
            document.getElementById("VerifyUserName").addEventListener('paste', (e) => { e.preventDefault(); });
        }
        if (verifyPasswordEl != null) {
            document.getElementById("VerifyPassword").addEventListener('paste', (e) => { e.preventDefault(); });
        }

        if (typeof (this.verifyMembershipButton) != 'undefined' && this.verifyMembershipButton != null) {
            this.verifyMembershipButton.addEventListener('click',
                (e) => {
                    this.clearValidationErrors();

                    if (!document.getElementById('MemberOrganisation').checkValidity() ||
                        !document.getElementById('OrganisationNumber').checkValidity() ||
                        !document.getElementById('MemberNumber').checkValidity()) {
                        return;
                    }
                    e.preventDefault();
                    this.finishStepOne();
                });
        }
        if (typeof (this.verifyPersonalDetailsButton) != 'undefined' && this.verifyPersonalDetailsButton != null) {

            this.verifyPersonalDetailsButton.addEventListener('click',
                (e) => {
                    this.clearValidationErrors();

                    if (!document.getElementById('FirstName').checkValidity() ||
                        !document.getElementById('LastName').checkValidity() ||
                        !this.validateUserName() ||
                        !this.validatePassword() ||
                        !this.validateWorkPlace()) {
                        return;
                    }
                    e.preventDefault();
                    this.finishStepTwo();
                });
        }
    }

    finishStepOne() {
        var self = this;
        self.verifyMembershipButton.setAttribute("disabled", true);
        fetch('/creatememberapi/getuserticketandaccount/',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    orgNr: document.getElementById('OrganisationNumber').value,
                    memberNr: document.getElementById('MemberNumber').value,
                    memberorgId: document.getElementById('MemberOrganisation').value
                })
            }).then(function (response) {
                return response.json();
            }).then(function (json) {

                self.verifyMembershipButton.removeAttribute("disabled");

                //verify ticket
                if (json.ticket == null || !json.ticket.isValid || json.ticket.ticket === '') {
                    self.addValidationError(self.verifyMembershipButton,
                        "Det gick inte att verifiera din användare. Kontrollera att organisationsnummer och medlemsnummer är rätt angivet.");
                    return;
                }

                //account
                if (json.account == null || json.account.kontoID === "") {
                    self.addValidationError(self.verifyMembershipButton,
                        "Det gick inte att verifiera ditt konto");
                    return;
                }
                //set step2 values
                const accountName = document.getElementById('AccountName');
                accountName.value = json.account.marknadsNamn;
                const accountId = document.getElementById('AccountId');
                accountId.value = json.account.kontoID;
                const ticket = document.getElementById('Ticket');
                ticket.value = json.ticket.ticket;

                //light up step 2
                self.stepone.classList.add('hidden');
                self.steptwo.classList.remove('hidden');

            }).catch((ex) => {
                console.log(ex);
            });
    }
    finishStepTwo() {
        var self = this;
        self.verifyPersonalDetailsButton.setAttribute("disabled", true);
        fetch('/creatememberapi/validateusernameandgetcontact/',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    orgNr: document.getElementById('OrganisationNumber').value,
                    memberNr: document.getElementById('MemberNumber').value,
                    memberorgId: document.getElementById('MemberOrganisation').value,
                    ticket: document.getElementById('Ticket').value,
                    email1: document.getElementById('UserName').value,
                    email2: document.getElementById('VerifyUserName').value
                })
            })
            .then(function (response) {
                return response.json();
            }).then(function (json) {

                //if username already exists - show message
                if (json.userNameAlreadyExists) {
                    self.verifyPersonalDetailsButton.removeAttribute("disabled");
                    self.addValidationError(self.verifyPersonalDetailsButton,
                        "E-posten du angett används redan. Klicka på Logga in-länken längst upp på sidan och välj sedan Glömt lösenord.");
                    return;
                }

                //Contact person exists username don't exist,
                if (json.contactPerson != null && json.contactPerson.antalRader > 0) {
                    var contactPersonId = json.contactPerson.kontaktperson[0].kontaktpersonID;
                    //create web user
                    self.createWebUser(contactPersonId).then(function (webUserId) {
                        if (webUserId !== '') {
                            //send email
                            self.sendEmail(webUserId).then(function (retVal) {
                                self.verifyPersonalDetailsButton.removeAttribute("disabled");
                                if (retVal === true) {
                                    //light up step 3
                                    self.steptwo.classList.add('hidden');
                                    self.stepthree.classList.remove('hidden');
                                } else {
                                    self.addValidationError(self.verifyPersonalDetailsButton,
                                        "Ett fel inträffade när ditt bekräftelsemejl skulle skapas.");
                                }
                            }).catch(ex => {
                                self.addValidationError(self.verifyPersonalDetailsButton, ex);
                            });
                        }
                    }).catch(ex => {
                        self.addValidationError(self.verifyPersonalDetailsButton, ex);
                    });
                    return;
                }
                //Contact person don't exist username don't exist
                if (json.contactPerson == null || json.contactPerson.antalRader < 1) {
                    const workPlaceSelect = document.getElementById('WorkPlace');

                    //if no workplace selected populate list
                    if (workPlaceSelect.value === "") {
                        self.addWorkPlaceList();
                        self.verifyPersonalDetailsButton.removeAttribute("disabled");
                        return;
                    }
                    //create contact person
                    self.createContactPerson().then(function (contactPersonId) {
                        if (contactPersonId !== '') {
                            //create web user
                            self.createWebUser(contactPersonId).then(function (webUserId) {
                                if (webUserId !== '') {
                                    //send email
                                    self.sendEmail(webUserId).then(function (retVal) {
                                        self.verifyPersonalDetailsButton.removeAttribute("disabled");
                                        if (retVal === true) {
                                            //light up step 3
                                            self.steptwo.classList.add('hidden');
                                            self.stepthree.classList.remove('hidden');
                                        } else {
                                            self.addValidationError(self.verifyPersonalDetailsButton,
                                                "Ett fel inträffade när ditt bekräftelsemejl skulle skapas.");
                                        }
                                    }).catch(ex => {
                                        self.addValidationError(self.verifyPersonalDetailsButton, ex);
                                    });
                                }
                            }).catch(ex => {
                                self.addValidationError(self.verifyPersonalDetailsButton, ex);
                            });
                        }
                    }).catch(ex => {
                        self.addValidationError(self.verifyPersonalDetailsButton, ex);
                    });
                }


            }).catch((ex) => {
                console.log(ex);
            });
    }

    addWorkPlaceList() {
        var self = this;
        fetch('/creatememberapi/getworkplacelist/',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    orgNr: document.getElementById('OrganisationNumber').value,
                    memberNr: document.getElementById('MemberNumber').value,
                    memberorgId: document.getElementById('MemberOrganisation').value,
                    ticket: document.getElementById('Ticket').value,
                    accountId: document.getElementById('AccountId').value
                })
            })
            .then(function (response) {
                return response.json();
            }).then(function (json) {
                console.log('workplaces');
                console.log(json);

                if (json == null || json.antalRader === 0) {
                    self.addValidationError(self.verifyPersonalDetailsButton,
                        "Vi kunde inte hitta några arbetställen för din registrering. Kontakta medlem@transportforetagen.se eller ring 08 762 71 99 för hjälp.");
                    return;
                }

                const workplaceDropDownWrapper = document.getElementById('steptwo__workplacelist');
                const workplaceDropDown = document.getElementById('WorkPlace');
                workplaceDropDownWrapper.classList.remove('hidden');
                for (var i = 0; i < json.length; i++) {
                    var option = document.createElement("option");
                    option.text = json[i].text;
                    option.value = json[i].value;
                    workplaceDropDown.append(option);
                }

            }).catch((ex) => {
                console.log(ex);
            });
    }

    createWebUser(contactPersonId) {
        return new Promise(function (resolve, reject) {
            fetch('/creatememberapi/createwebuser/',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        orgNr: document.getElementById('OrganisationNumber').value,
                        memberNr: document.getElementById('MemberNumber').value,
                        memberOrgId: document.getElementById('MemberOrganisation').value,
                        ticket: document.getElementById('Ticket').value,
                        email1: document.getElementById('UserName').value,
                        password1: document.getElementById('Password').value,
                        password2: document.getElementById('VerifyPassword').value,
                        contactPersonId: contactPersonId
                    })
                })
                .then(function (response) {
                    return response.json();
                }).then(function (json) {
                    //error
                    if (json == null || json.webbanvandare == null) {
                        reject("Ett fel inträffade när din webbbanvändare skulle skapas. Kontakta medlem@transportforetagen.se eller ring 08 762 71 99 för hjälp.");
                    } else {
                        //ok, set hidden value
                        resolve(json.webbanvandare.webbanvandareID);
                    }
                }).catch((ex) => {
                    reject(ex);
                });
        });
    }

    createContactPerson() {
        console.log('create contactperson');
        return new Promise(function (resolve, reject) {
            fetch('/creatememberapi/createcontactperson/',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        orgNr: document.getElementById('OrganisationNumber').value,
                        memberNr: document.getElementById('MemberNumber').value,
                        memberorgId: document.getElementById('MemberOrganisation').value,
                        ticket: document.getElementById('Ticket').value,
                        firstName: document.getElementById('FirstName').value,
                        lastName: document.getElementById('LastName').value,
                        email1: document.getElementById('UserName').value,
                        email2: document.getElementById('VerifyUserName').value,
                        workPlaceId: document.getElementById('WorkPlace').value
                    })
                })
                .then(function (response) {
                    return response.json();
                }).then(function (json) {
                    if (json == null || json.kontaktperson == null) {
                        reject("Ett fel inträffade när kontaktpersonuppgifterna skulle skapas. Kontakta medlem@transportforetagen.se eller ring 08 762 71 99 för hjälp.");
                    } else {
                        resolve(json.kontaktperson.kontaktpersonID);
                    }
                }).catch((ex) => {
                    reject(ex);
                });
        });
    }

    sendEmail(webUserId) {
        return new Promise(function (resolve, reject) {
            fetch('/creatememberapi/sendconfirmusermail/',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        orgNr: document.getElementById('OrganisationNumber').value,
                        memberNr: document.getElementById('MemberNumber').value,
                        memberorgId: document.getElementById('MemberOrganisation').value,
                        ticket: document.getElementById('Ticket').value,
                        firstname: document.getElementById('FirstName').value,
                        email1: document.getElementById('UserName').value,
                        password1: document.getElementById('Password').value,
                        webUserId: webUserId
                    })
                })
                .then(function (response) {
                    return response.json();
                }).then(function (json) {
                    //mail sent - ok // just return json variable?
                    if (json === true) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }

                }).catch((ex) => {
                    reject(ex);
                });
        });
    }
}

document.addEventListener("DOMContentLoaded", () => new CreateMember());